import { setLocale, type LocaleObject } from "yup";

interface NotTypeParams {
  type: string;
  value: unknown;
  originalValue: unknown;
}

const printValue = (value: unknown, quoteStrings?: boolean): string => {
  if (value === null) {
    return "null";
  }
  if (value === undefined) {
    return "undefined";
  }
  if (typeof value === "string" && quoteStrings) {
    return `"${value}"`;
  }
  if (typeof value === "object") {
    return JSON.stringify(value);
  }
  return String(value);
};

const mixed = {
  default: "Ce champ est invalide",
  required: "Ce champ est requis",
  oneOf: "Ce champ doit avoid l'une des valeurs suivantes : ${values}",
  notOneOf: "Ce champ ne doit pas avoir l'une des valeurs suivantes : ${values}",
  notType: ({ type, value, originalValue }: NotTypeParams): string => {
    const isCast = originalValue !== null && originalValue !== value;
    let msg =
      `Ce champ doit être de type \`${type}\`, ` +
      `mais sa valeur actuelle est : \`${printValue(value, true)}\`` +
      (isCast ? ` (transformé depuis la valeur \`${printValue(originalValue, true)}\`).` : ".");

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
};

const string = {
  length: "Ce champ doit être de contenir ${length} caractères",
  min: "Ce champ doit contenir au moins ${min} caractères",
  max: "Ce champ doit avoir un maximum de ${max} caractères",
  matches: 'Ce champ doit matcher la regex suivante : "${regex}"',
  email: "Ce champ doit être une addresse email valide",
  url: "Ce champ doit être une URL valide",
  trim: 'Ce champ doit être une chaine "trimmé"',
  lowercase: "Ce champ doit être en minuscule",
  uppercase: "Ce champ doit être en majuscule",
};

const number = {
  min: "Ce champ doit être supérieur ou égal à ${min}",
  max: "Ce champ doit être inférieur ou égal à ${max}",
  less: "Ce champ doit être inférieur à ${less}",
  more: "Ce champ doit être supérieur à ${more}",
  notEqual: "Ce champ doit être différent de ${notEqual}",
  positive: "Ce champ doit être un nombre positif",
  negative: "Ce champ doit être un nombre négatif",
  integer: "Ce champ doit être un nombre",
};

const date = {
  min: "Ce champ doit être une date ultérieure à ${min}",
  max: "Ce champ doit être une date antérieure à ${min}",
};

const boolean = {};

const object = {
  noUnknown: "Ce champ ne peut contenir des clés non spécifiés",
};

const array = {
  min: "Ce champ doit contenir au moins ${min} élements",
  max: "Ce champ doit contenir au moins ${max} élements",
};

const locale: LocaleObject = {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
};

setLocale(locale);
